<template>
  <div>
    <b-card no-body>
      <b-card-header>
        <b>Member Organizations</b>
          <b-button type="button" variant="outline-primary" size="sm" class="float-right" @click="showCreateMemberModal = true">
          <span class="button-text">Add Organization</span>
        </b-button>        
      </b-card-header>
      <div v-if="hasOrganizations">
        <b-list-group v-for="memOrg in _.sortBy(memberOrganizations,'title')" :key="memOrg.id" flush>
          <b-list-group-item>          
            <a href="" @click.prevent="toggleDeleteOrgModal(memOrg)">
              {{memOrg.title}} 
            </a>
              <img v-if="defaultOrg == memOrg.id" :src="'static/img/Primary.png'" height="21" width="21">           
          </b-list-group-item>
        </b-list-group>
      </div>

      <div v-if="!hasOrganizations">
        <b-list-group flush>
          <b-list-group-item>
            <p>
              {{ !hasOrganizations ? 'This Organization does not have any Groups.' : 'Howdy!' }}
            </p>
          </b-list-group-item>
        </b-list-group>
      </div>
    </b-card>
    <CreateGroupOrgMembershipModal 
     :showModal.sync="showCreateMemberModal"
     :existingMemOrg="existingMemberIds"
     :groupId="groupId"
     >
    </CreateGroupOrgMembershipModal>
    <DeleteGroupOrgMembershipModal 
     :showModal.sync="showDeleteMemberModal"
     :orgId = "toDeleteOrgId"
     :orgName = "toDeleteOrgName"     
     >
    </DeleteGroupOrgMembershipModal>
  </div>
</template>

<script>
  import CreateGroupOrgMembershipModal from '@/components/Admin/CreateGroupOrgMembershipModal'
  import DeleteGroupOrgMembershipModal from '@/components/Admin/DeleteGroupOrgMembershipModal'
  export default {
    name: 'GroupOrganizations',
    components: {
      CreateGroupOrgMembershipModal,
      DeleteGroupOrgMembershipModal
    },
    data: function () {
      return {
        showCreateMemberModal: false,
        showDeleteMemberModal: false,
        toDeleteOrgId: null,
        toDeleteOrgName: null
      }
    },
    props: {
      memberOrganizations: Array,
      groupId: Number,
      groupName: String,
      defaultOrg: Number
    },
    computed: {
      existingMemberIds: function () {
        return this.memberOrganizations.map(x => {
          return x.id
        })
      },
      hasOrganizations: function () {
        return this.memberOrganizations.length > 0
      }
    },
    methods: {
      toggleDeleteOrgModal: function (memOrg) {
        this.toDeleteOrgId = memOrg.id
        this.toDeleteOrgName = memOrg.title
        this.showDeleteMemberModal = true
      }
    }
  }
</script>
<style></style>



// WEBPACK FOOTER //
// src/components/Admin/GroupOrganizations.vue